import { CommunityService } from '@common/lib/api';
import * as community from './types';

const actions = {
  // 핫이슈 리스트
  async [community.FETCH_HOT_LIST](context, params) {
    const { data } = await CommunityService.getHotList(params);
    context.commit(community.SET_HOT_LIST, data);
    return data;
  },
  // 자유게시판
  async [community.FETCH_BOARD](context, params) {
    context.commit(community.SET_BOARD, {});
    const { data } = await CommunityService.getBoard(params);
    context.commit(community.SET_BOARD, data);
  },
  async [community.FETCH_BOARD_LIST](context, params) {
    const { data } = await CommunityService.getBoardList(params);
    context.commit(community.SET_BOARD_LIST, data);
  },
  async [community.CREATE_BOARD](context, params) {
    await CommunityService.createBoard(params);
  },
  async [community.UPDATE_BOARD](context, params) {
    await CommunityService.updateBoard(params);
  },
  async [community.DELETE_BOARD](context, params) {
    await CommunityService.deleteBoard(params);
  },
  async [community.LIKE_BOARD](context, params) {
    await CommunityService.likeBoard(params);
  },
  async [community.UNLIKE_BOARD](context, params) {
    await CommunityService.unlikeBoard(params);
  },
  async [community.REPORT_BOARD](context, params) {
    await CommunityService.reportBoard(params);
  },
  // 자유게시판 - 답글
  async [community.FETCH_BOARD_REPLY_LIST](context, params) {
    const { data } = await CommunityService.getBoardReplyList(params);
    context.commit(community.SET_BOARD_REPLY_LIST, data);
  },
  async [community.FETCH_BOARD_REPLY_LIST_MINE](context, params) {
    const { data } = await CommunityService.getBoardReplyListMine(params);
    context.commit(community.SET_BOARD_REPLY_LIST_MINE, data);
  },
  async [community.CREATE_BOARD_REPLY](context, params) {
    await CommunityService.createBoardReply(params);
  },
  async [community.UPDATE_BOARD_REPLY](context, params) {
    await CommunityService.updateBoardReply(params);
  },
  async [community.DELETE_BOARD_REPLY](context, params) {
    await CommunityService.deleteBoardReply(params);
  },
  async [community.LIKE_BOARD_REPLY](context, params) {
    await CommunityService.likeBoardReply(params);
  },
  async [community.UNLIKE_BOARD_REPLY](context, params) {
    await CommunityService.unlikeBoardReply(params);
  },
  async [community.REPORT_BOARD_REPLY](context, params) {
    await CommunityService.reportBoardReply(params);
  },
  // 지식인
  async [community.FETCH_KNOWHOW](context, params) {
    context.commit(community.SET_KNOWHOW, {});
    const { data } = await CommunityService.getKnowhow(params);
    context.commit(community.SET_KNOWHOW, data);
  },
  async [community.FETCH_KNOWHOW_LIST](context, params) {
    const { data } = await CommunityService.getKnowhowList(params);
    context.commit(community.SET_KNOWHOW_LIST, data);
    return data;
  },
  async [community.FETCH_KNOWHOW_ANSWER_LIST](context, params) {
    const { data } = await CommunityService.getKnowhowAnswerList(params);
    context.commit(community.SET_KNOWHOW_ANSWER_LIST, data);
  },
  async [community.FETCH_KNOWHOW_ANSWER_DETAIL](context, params) {
    const { data } = await CommunityService.getKnowhowAnswerDetail(params);
    context.commit(community.SET_KNOWHOW_ANSWER_DETAIL, data);
  },
  async [community.CREATE_KNOWHOW](context, params) {
    await CommunityService.createKnowhow(params);
  },
  async [community.CREATE_KNOWHOW_ANSWER](context, params) {
    await CommunityService.createKnowhowAnswer(params);
  },
  async [community.UPDATE_KNOWHOW](context, params) {
    await CommunityService.updateKnowhow(params);
  },
  async [community.DELETE_KNOWHOW](context, params) {
    await CommunityService.deleteKnowhow(params);
  },
  async [community.LIKE_KNOWHOW](context, params) {
    await CommunityService.likeKnowhow(params);
  },
  async [community.UNLIKE_KNOWHOW](context, params) {
    await CommunityService.unlikeKnowhow(params);
  },
  async [community.REPORT_KNOWHOW](context, params) {
    await CommunityService.reportKnowhow(params);
  },
  // 지식인 - 답글
  async [community.FETCH_KNOWHOW_REPLY_LIST](context, params) {
    const { data } = await CommunityService.getKnowhowReplyList(params);
    context.commit(community.SET_KNOWHOW_REPLY_LIST, data);
  },
  async [community.FETCH_KNOWHOW_REPLY_LIST_MINE](context, params) {
    const { data } = await CommunityService.getKnowhowReplyListMine(params);
    context.commit(community.SET_KNOWHOW_REPLY_LIST_MINE, data);
  },
  async [community.CREATE_KNOWHOW_REPLY](context, params) {
    await CommunityService.createKnowhowReply(params);
  },
  async [community.UPDATE_KNOWHOW_REPLY](context, params) {
    await CommunityService.updateKnowhowReply(params);
  },
  async [community.DELETE_KNOWHOW_REPLY](context, params) {
    await CommunityService.deleteKnowhowReply(params);
  },
  async [community.LIKE_KNOWHOW_REPLY](context, params) {
    await CommunityService.likeKnowhowReply(params);
  },
  async [community.UNLIKE_KNOWHOW_REPLY](context, params) {
    await CommunityService.unlikeKnowhowReply(params);
  },
  async [community.REPORT_KNOWHOW_REPLY](context, params) {
    await CommunityService.reportKnowhowReply(params);
  },

  // 사용자 신고
  async [community.REPORT_USER](context, params) {
    await CommunityService.reportUser(params);
  },

  // 인기글 리스트
  async [community.FETCH_HOT_POST_LIST](context, params) {
    const { data } = await CommunityService.getHotPosts(params);
    context.commit(community.SET_HOT_POST_LIST, data);
    return data;
  },
};

export default actions;
